import {
  ExamCenterProctorList,
  ExamCenterProctorListFilterSection,
} from '@exam-center/exam-center-proctor-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ProctorsPage() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-proctors/proctors');

  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR.VIEW]}>
      <PaperSection
        title='ผู้คุมสอบทั้งหมด'
        sx={(theme) => ({ height: '100%', borderRadius: theme.shape.rounded(2) })}
      >
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(4),
            p: theme.spacing(6),
            height: '100%',
          })}
        >
          <ExamCenterProctorListFilterSection />
          <ExamCenterProctorList examCenterCode={examCenterCode} />
        </Flex>
      </PaperSection>
    </PermissionGuard>
  );
}
